export default __webpack_public_path__ + "static/media/0002.c2f5a8f4.jpg";